'use strict';

var isArraysEqualEps$1 = require('../../../../_virtual/isArraysEqualEps.js_commonjs-exports.js');

isArraysEqualEps$1.__exports.__esModule = true;
isArraysEqualEps$1.__exports.default = isArraysEqualEps;
function isArraysEqualEps(arrayA, arrayB, eps) {
  if (arrayA && arrayB) {
    for (var i = 0; i !== arrayA.length; ++i) {
      if (Math.abs(arrayA[i] - arrayB[i]) > eps) {
        return false;
      }
    }
    return true;
  }
  return false;
}
